const MainErrorMC = () => (
  <div className="flex flex-col items-center justify-center max-md:my-10 md:my-20 px-4">
    <div className="text-mc-wattle max-md:text-5xl md:text-[64px] font-semibold">500</div>
    <h1 className="font-semibold mt-5 text-2xl text-mc-athens-gray max-w-150">
      Scheduled Maintenance in Progress
    </h1>
    <p className="mt-2 text-mc-santas-gray max-w-150 text-center">
      We&apos;re working hard to improve your experience. Please check back shortly
    </p>
    <a
      className="mt-7 h-10 w-50 flex items-center justify-center text-center font-bold rounded-sm no-underline default-transition text-mc-woodsmoke bg-mc-wattle hover:bg-mc-buttered-rum"
      href={'/'}
    >
      Home
    </a>
  </div>
);

export default MainErrorMC;
